import getKhattabatSelectsStore from "../../../../../../stores/khattabat-stores/selects-store";
import { TKhattabatMessage } from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Messages from "../../../../khattabat-clients/conversation/body/messages";
import SideActions from "../SideActions";
import Comments from "./Comments";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";

const Conversation = withLiteObserverAndTheme<{
  clientID: number;
  clientUUID: string;
  alkhattabaUUID: string;
  matchID: number;
  matchUUID: string;
  messages: TKhattabatMessage[];
  oneOTwoConversationId: string;
  matchStatus: string;
  matchConversationID: string;
  isOpenedConversation: boolean;
  matchUnreadMessages: number;
  matchConvesationIsDisabled: boolean;
  conversationID: string;
  isHighlighted: boolean;
  matchComments: TKhattabatMessage[];
  matchHasDeletedTheConversation: boolean;
}>((props) => {
  const {
    clientID,
    clientUUID,
    alkhattabaUUID,
    matchID,
    matchUUID,
    messages,
    oneOTwoConversationId,
    matchConversationID,
    matchStatus,
    isOpenedConversation,
    matchUnreadMessages,
    matchConvesationIsDisabled,
    conversationID,
    isHighlighted,
    matchComments,
    matchHasDeletedTheConversation,
    theme
  } = props;
  const { colors } = theme;
  const isConversationMarked = getKhattabatSelectsStore().isMarkedConversation({
    userID: matchID
  });

  return !isOpenedConversation ? null : (
    <ET3Div
      width={1510}
      height={520}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => { }}
    >
      <ET3Div
        width={1510}
        height={480}
        alignItems={"center"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => { }}
      >
        <ET3Div
          width={1188}
          height={428}
          alignItems={"center"}
          fDirection={"row"}
          style={{
            border: isConversationMarked
              ? `2px solid ${colors.all.green}`
              : "none",
            borderRadius: 20
          }}
          color={""}
          justifyContent={"center"}
          withShadow={false}
          isExtendable={true}
          isScrollable={false}
          onClick={() => { }}
        >
          <Messages
            messages={messages}
            conversationID={matchConversationID}
            alkhattabaUUID={alkhattabaUUID}
            userUUID={clientUUID}
            userID={clientID}
            peerID={matchID}
            peerUUID={matchUUID}
            conversationType={"101M"}
            oneOTwoConversationId={oneOTwoConversationId}
            oneOOneCId={""}
            applicationStatus={""}
          />
        </ET3Div>
        <SideActions
          matchID={matchID}
          matchStatus={matchStatus}
          alkhattabaUUID={alkhattabaUUID}
          matchUUID={matchUUID}
          matchUnreadMessages={matchUnreadMessages}
          matchConvesationIsDisabled={matchConvesationIsDisabled}
          conversationID={conversationID}
          isHighlighted={isHighlighted}
          matchHasDeletedTheConversation={matchHasDeletedTheConversation}
        />
      </ET3Div>

      <Comments
        matchComments={matchComments}
        matchConversationID={matchConversationID}
        alkhattabaUUID={alkhattabaUUID}
        matchUUID={matchUUID}
        matchID={matchID}
        clientID={clientID}
        clientUUID={clientUUID}
        oneOOneCId={""}
      />
      <Et3Margin top={5} bottom={5} left={0} right={0} />
    </ET3Div>
  );
});

export default Conversation;
